import React, { Component, Fragment, Suspense } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { injectIntl, FormattedMessage } from '../../../../components/Intl/withIntl.js';
import { Container, Row, Col, Badge, Collapse, Tooltip, OverlayTrigger, ProgressBar, Button } from 'react-bootstrap';

import ReactGA4 from 'react-ga4';
// import ReactToPrint from '../../../../components/Content/ReactToPrint.js';
import slugify from 'slugify';

import config from '../../../../config.js';
import { getFile } from '../../../../util/file.js';
import { capitalizeFirstLetter, truncateToChar } from '../../../../util/text.js';
import { formatPrice } from '../../../../util/price.js';

import { getProduct, getProductPrice, getProductSlug, getProductOption, getProductsFromStore, getFilteredProducts, getProductSpecialPrice, getProductSpecialPriceDateThreshold, memoizedGetProducts, getProductSpecialPrices } from '../../ProductActions.js';
import { getCartVouchers, formatAnalyticsItems, getCartQuantityStep, getCartItemByProduct, getCartItemFromProduct } from '../../../Cart/CartActions.js';
import { getPanelBySlugAndLanguage, getContentBlockItemsByName, getContentBlockItemValue, getCmsPageSeoDescription, memoizedGetPanelBySlugAndLanguage, CMS_RELATED_POSTS_COUNT } from '../../../Cms/CmsActions.js';
import { getUserGroup, getUserGroupOption, USER_GROUP_DEFAULT } from '../../../User/UserGroupActions.js';
import { getCurrentCurrency, defaultCurrency } from '../../../Currency/CurrencyActions.js';
import { getTranslation, getLanguagePath, getDefaultLanguage, getCountryName } from '../../../Intl/IntlHelper.js';
import { getReferral } from '../../../App/AppActions.js';

import Icon from '../../../../components/Content/Icon.js';
import ErrorPage from '../../../Error/pages/ErrorPage.js';
import withRouter from '../../../../components/Router/WithRouter.js';
import Breadcrumbs from '../../../App/components/view/Breadcrumbs.js';
import FileLoader from '../../../../components/Content/FileLoader.js';
import LazyLoader from '../../../../components/Content/LazyLoader.js';
import HtmlComponent from '../../../../components/Text/HtmlComponent.js';
import Slider from '../../../../components/Content/Slider.js';
import Price from '../../../Currency/components/view/Price.js';
import CmsPanel from '../../../Cms/components/content/CmsPanel.js';
import ProductCapacityPrice from '../../components/view/ProductCapacityPrice.js';
import ProductWeight from '../../components/view/ProductWeight.js';
import ProductSnippet from '../../components/view/ProductSnippet.js';
import ProductNutrition, { hasNutritionValues } from '../../components/view/ProductNutrition.js';
import ProductAllergens, { hasAllergens } from '../../components/view/ProductAllergens.js';
// import ProductPrint from '../../components/view/ProductPrint.js';
import ProductListItem from '../../components/list/ProductListItem.js';
import CartItemQuantitySelector from '../../../Cart/components/form/CartItemQuantitySelector.js';
import ReviewSummary from '../../../Review/components/view/ReviewSummary.js';
import PreFooter from '../../../App/components/PreFooter.js';
import SocialShare from '../../../../components/Social/SocialShare.js';
import VoucherProgress from '../../../Voucher/components/view/VoucherProgress.js';
import ProductRelatedPosts from '../../components/view/ProductRelatedPosts.js';
import Chrono from '../../../../components/Time/Chrono.js';
import ProductSeo from '../../components/view/ProductSeo.js';
import ProductSpecialPriceQuantityInfo from '../../components/view/ProductSpecialPriceQuantityInfo.js';
import ProductOfferSelector from '../../components/view/ProductOfferSelector.js';
import StarRating from '../../../Review/components/view/StarRating.js';
import Flag from '../../../../components/Flag/Flag.js';

class ProductViewPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isMounted: false,
            mainPicture: '',
            // displayVideo: false,
            detailsTab: 'conservation',
            variation: null,
        };
    }

    // shouldComponentUpdate(nextProps, nextState) {
    //     return this.props.page !== nextProps.page || this.props.product !== nextProps.product;
    // }

    componentDidMount() {
        if(this.props.product) {
            // this.initMainPicture();
            this.initVariation();
            this.handleTrackAnalytics();
        }
        this.setState({
            isMounted: true,
        });
    }

    componentDidUpdate(prevProps, prevState) {
        if(prevProps.product !== this.props.product) {
            // this.initMainPicture();
            this.initVariation();
            this.handleTrackAnalytics();
        }
    }

	getProducts() {
		return this.props.products;
	}

    getCurrentProduct() {
        if((this.props.product || {}).isVariation) {
            // Redirect to main product page with variation id in query param
            const variationFrom = this.getProducts().find(product => (product.variations || []).find(variation => variation.productId === this.props.product._id));
            variationFrom && this.props.navigate(getLanguagePath(`${getProductSlug(variationFrom)}?variation=${this.props.product._id}`, this.props.intl.locale));
        }
        return {
            ...this.props.product,
            ...(this.state.variation || {}),
        };
    }

    getTranslation(field) {
        return getTranslation(this.getCurrentProduct(), field, this.props.intl.locale);
    }

    getDiscount() {
        const { userGroup, referral } = this.props;
        const product = this.getCurrentProduct();
        const displayPriceHT = getUserGroupOption(userGroup, 'displayPriceHT');
        return 100 - Math.round((getProductPrice(product, null, userGroup, !displayPriceHT, referral) * 100) / product[displayPriceHT ? 'priceHT' : 'priceTTC']);
    }

	getAdditionnalPictures() {
		let product = this.getCurrentProduct();

        if(!product.pictures || !product.pictures.length) {
            product = this.props.product;
        }

		return (product.pictures || []).filter((path, index) => (!this.state.mainPicture && index) || (this.state.mainPicture && path !== this.state.mainPicture));
	}

    getAssociatedProducts() {
		const associatedProductsCount = 6;
        const { userGroup } = this.props;
        let associatedProducts = [];
        const associatedProductsIds = (getContentBlockItemsByName(this.props.page.blocks, 'associated-products') || []).map(item => item.text);
        if(associatedProductsIds && associatedProductsIds.length > 0) {
            associatedProducts = associatedProductsIds.map(id => this.getProducts().find(product => product._id === id)).filter(product => product?.isAvailable);
        }

        if(associatedProducts.length === associatedProductsCount) {
            return associatedProducts;
        }

        return [
            ...(associatedProducts || []),
            ...(this.getProducts() || [])
                .filter(product => (
					(product.isAvailable && !product.isVariation && !product.isPack)
					&& (!(getProductOption(product, 'visibleGroups') || []).length || getProductOption(product, 'visibleGroups').includes((userGroup || {}).identifier))
					&& (
						getTranslation(product, 'categories', this.props.intl.locale).filter(category => this.getTranslation('categories').includes(category)).length > 1
						|| getTranslation(product, 'categories', getDefaultLanguage()).filter(category => getTranslation(this.props.product, 'categories', getDefaultLanguage()).includes(category)).length > 1
					)
					&& product._id !== this.props.product._id
				))
				.sort((pA, pB) => (getTranslation(pA, 'categories', this.props.intl.locale).sort((cA, cB) => cA.localeCompare(cB)).join('-').toLowerCase() === getTranslation(pB, 'categories', this.props.intl.locale).sort((cA, cB) => cA.localeCompare(cB)).join('-').toLowerCase() ? 1 : -1))
                .slice(0, associatedProductsCount - associatedProducts.length),
        ];
    }

    // handleToggleDetailsTab = tab => {
    //     this.setState({
    //         detailsTab: tab,
    //     });
    // }

    // initMainPicture = () => {
    //     let product = this.getCurrentProduct();
    //     if(!(product.pictures || [])[0]) {
    //         product = this.props.product;
    //     }
    //     this.setState({
    //         mainPicture: (product.pictures || []).find(picture => picture.includes('.gif') || picture.includes('.webm') || picture.includes('.mp4')) || product.pictures[0],
    //     });
    // };

    initVariation = () => {
        if(this.props.search.get('variation')) {
            this.setState({
                variation: this.getProducts().find(product => product._id === this.props.search.get('variation')),
            });
        }
    };

    handleSetMainPicture = event => this.setState({ mainPicture: event.target.getAttribute('data-path') }, () => window.scrollTo({ top: 0, left: 0, behavior: 'instant' }));

    handleOpenInfoTab = () => this.setState({ detailsTab: 'info' });

    handleOpenCompositionTab = () => this.setState({ detailsTab: 'composition' });

    handleOpenNutritionalValuesTab = () => this.setState({ detailsTab: 'nutrional-values' });

    handleOpenConservationTab = () => this.setState({ detailsTab: 'conservation' });

    handleSetVariation = variationId => {
        this.setState({
            variation: this.getProducts().find(product => product._id === variationId),
        });
    };

    getSectionAnchorId = section => `product-${this.props.product._id}-${section}`;

    handleGoToSection = (section, collapseTab = null) => {
        if(collapseTab) {
            this.setState({ detailsTab: collapseTab });
        }
        if(typeof document !== 'undefined') {
            const element = document.getElementById(this.getSectionAnchorId(section));
            if(element) {
                const offset = 150;
                const top = element.getBoundingClientRect().top + window.pageYOffset - offset;
                window.scrollTo({ top, behavior: 'smooth' });
            }
        }
    };

    handleTrackAnalytics = () => {
        const { intl, currency, userGroup, referral } = this.props;
        const product = this.getCurrentProduct();
        const productPrice = getProductPrice(product, 1, userGroup, !getUserGroupOption(userGroup, 'displayPriceHT'), referral);
        if(product && typeof window !== 'undefined') {
            if(config.google.analytics.trackingCodeGA4) {
                // GA: New
                ReactGA4.event('view_item', {
                    currency,
                    value: productPrice,
                    items: formatAnalyticsItems([getCartItemFromProduct(product, 1, intl.locale, userGroup, { referral })]),
                });
            }

            if(window.dataLayer) {
                window.dataLayer.push({ ecomm_prodid: (product.slug || product._id).toLowerCase() });
                window.dataLayer.push({ ecomm_pagetype: 'product' });
                window.dataLayer.push({ ecomm_totalvalue: productPrice });
            }

            if(typeof window !== 'undefined' && window.fbq) {
                window.fbq('track', 'ViewContent', {
                    content_name: product.name,
                    content_category: product.brand,
                    content_ids: [product.slug || product._id],
                    content_type: 'product',
                    value: productPrice,
                    currency: 'EUR',
                });
            }
        }
    };

    isAvailable() {
        return this.props.product.isAvailable && (!this.props.userGroup || !(getProductOption(this.props.product, 'visibleGroups') || []).length || getProductOption(this.props.product, 'visibleGroups').includes((this.props.userGroup || {}).identifier));
    }

    renderAttributes() {
        const product = this.getCurrentProduct();
        const foodData = product.foodData || {};
        const meatCountries = (foodData.meatOrigin || []).map(code => getCountryName(code, this.props.intl.locale)).filter(Boolean);
        const originCountry = getCountryName(product.countryOfOrigin, this.props.intl.locale);
        if((product.attributes || []).length || product.brand || meatCountries.length || originCountry) {
            return (
                <table border="0" className="w-100 bg-white rounded-3 p-2">
                    <tbody>
                        {this.renderAttribute({
                            name: 'brand',
                            value: product.brand,
                        })}
                        {(product.attributes || []).sort((attributeA, attributeB) => attributeA.sort - attributeB.sort).map(attribute => {
                            return this.renderAttribute({
                                ...attribute,
                                ...((attribute.translations || []).find(translation => translation.lang === this.props.intl.locale) || {}),
                            });
                        })}
                        {this.renderAttribute({
                            name: 'weight',
                            value: product.weight,
                            display: <ProductWeight product={product} hideLabel />,
                        })}
                        {meatCountries.length > 0 && this.renderAttribute({
                            name: 'meatOrigin',
                            label: 'Meat origin',
                            value: meatCountries.join(', '),
                            display: (foodData.meatOrigin || []).map(country => <Flag key={country} country={country} />), // meatCountries.join(', '),
                        })}
                        {originCountry && this.renderAttribute({
                            name: 'countryOfOrigin',
                            label: 'Country of origin',
                            value: originCountry,
                            display: <Flag country={product.countryOfOrigin} />, // originCountry,
                        })}
                    </tbody>
                </table>
            );
        }
    }

    renderAttribute(attribute) {
        return (
            <tr key={attribute.id} className="">
                <th className="pe-2 mb-2 pb-2" style={{ fontWeight: 'normal' }}><FormattedMessage id={`productAttribute${capitalizeFirstLetter(attribute.name)}`} defaultMessage={attribute.label || capitalizeFirstLetter(attribute.name)} />:</th>
                <td><strong>{this.renderAttributeValue(attribute)}</strong></td>
            </tr>
        );
    }

    renderAttributeValue(attribute) {
        if(attribute.name === 'dryIndex') {
            const value = parseInt(attribute.value, 10);
            // return (
            //     <div>{Array(value).fill(1).map((i, index) => <Icon key={index} icon="add" />)}</div>
            // );
            return (
                <OverlayTrigger
                    overlay={
                        <Tooltip id={attribute.name}>
                            <FormattedMessage id={`productAttribute${capitalizeFirstLetter(attribute.name)}${value || 1}`} />
                        </Tooltip>
                    }
                >
                    <ProgressBar variant={value > 3 ? 'dangerlight' : 'light'} label={`${value}/5`} now={value} max={5} className="text-black" />
                </OverlayTrigger>
            );
        }
		if(attribute.name === 'weight' || attribute.name === 'meatOrigin' || attribute.name === 'countryOfOrigin') {
			return attribute.display || attribute.value;
		}
        return attribute.value && <CmsPanel slug={`product-attribute-${slugify(attribute.name || '').toLowerCase()}-${slugify(attribute.value || '').toLowerCase()}`} defaultDisplay={attribute.display || attribute.value} />;
    }

    renderCategories() {
        return this.getTranslation('categories').sort().map((category, index) => {
            return (
                <span key={category}><Badge bg="light" className="h6 text-black">{capitalizeFirstLetter(category)}</Badge>{' '}</span>
            );
        });
    }

    renderDiscountBadge() {
        if(this.getDiscount() > 0) {
            return (
                <span className="position-absolute m-2 top-0 end-0">
                    <Badge bg="danger" className="fs-2 fw-bold px-2 py-1 shadow-sm"><FormattedMessage id="productDiscountPercent" defaultMessage="{discount}% off" values={{ discount: this.getDiscount() }} /></Badge>
                </span>
            );
        }
    }

    renderMainPicture() {
        let product = this.getCurrentProduct();
        if(!(product.pictures || [])[0]) {
            product = this.props.product;
        }
        const mainPicture = this.state.mainPicture
            || (false && this.state.isMounted && (product.pictures || []).find(picture => picture.includes('.gif') || picture.includes('.webm') || picture.includes('.mp4')))
            || product.pictures[0];

		const imageAlt = this.props.page.title || getTranslation(product, 'subtitle', this.props.intl.locale) || getTranslation(product, 'name', this.props.intl.locale);

        if(mainPicture) {
            const isVideo = mainPicture.includes('.gif') || mainPicture.includes('.webm') || mainPicture.includes('.mp4');
            const image = isVideo ? (product.pictures || []).find(picture => picture !== mainPicture) : mainPicture;
            let sizes = {};
            if(!this.state.mainPicture) {
                sizes = getProductOption(product, 'mainPictureOrientation') === 'portrait' ? { width: 400, height: 600 } : { width: 600, height: 400 };
            }
            return (
                <div className={classNames('position-relative', 'me-1', 'me-md-0', 'rounded', 'bg-light', 'product-image-wrapper', 'product-main-image', product.pictures.length < 2 && 'mb-2')}>
                    {
                        isVideo
                        ? (
                            <div style={{ maxHeight: '360px', overflow: 'hidden' }}>
                                <FileLoader filename={mainPicture} useAppUrl autoPlay loop muted alt={imageAlt} className="w-100 rounded" />
                            </div>
                        ) : (
                            <picture>
                                <source srcSet={getFile(mainPicture, { format: 'webp' })} width={sizes.width && `${sizes.width / 2}px`} height={sizes.height && `${sizes.height / 2}px`} type="image/webp" />
                                <source media="(min-width: 800px)" type="image/jpeg" srcSet={getFile(mainPicture)} width={sizes.width && `${sizes.width}px`} height={sizes.height && `${sizes.height}px`} />
                                {/* LCP element on the product page: eager + high priority so it is not
                                    queued behind the lazy images further down. */}
                                <img src={getFile(mainPicture)} alt={imageAlt} width={sizes.width && `${sizes.width / 2}px`} height={sizes.height && `${sizes.height / 2}px`} className="w-100 rounded shadow" loading="eager" fetchpriority="high" />
                            </picture>
                        )
                    }
                    {this.renderDiscountBadge()}
                </div>
            );
        }
    }

    renderSlider(isMobileView = false) {
        const pictures = this.getAdditionnalPictures();
        if(pictures.length < 1) {
            return null;
        }

        // Mobile (<= md) : bande horizontale de vignettes superposée en bas de l'image principale
        if(isMobileView) {
            return (
				<div className="d-flex d-lg-none justify-content-center gap-2 mt-n2 mb-2 px-2 position-relative overflow-auto" style={{ zIndex: 2 }}>
					{pictures.map((path, index) => (
						<div key={`${path}-${index}`} className="text-center position-relative flex-shrink-0" style={{ width: '120px' }}>
							<FileLoader filename={path} useAppUrl autoPlay loop muted alt={this.getTranslation('subtitle') || this.getTranslation('name')} className="w-100 rounded-2 object-fit-cover see-picture" height="70px" loading="lazy" data-path={path} onClick={this.handleSetMainPicture} />
							{/\.(mp4|webm|mpeg)(\?|$)/i.test(path) && (
								<span className="position-absolute top-50 start-50 translate-middle rounded-circl d-flex align-items-center justify-content-center pe-none" style={{ width: '28px', height: '28px' }}>
									<Icon icon="eye" className="text-white" />
								</span>
							)}
						</div>
					))}
				</div>
			);
        }

        const picturesBySlide = 4;
        const slides = [];
        const picturesTemp = [...pictures];
        while(picturesTemp.length > 0) {
            slides.push(picturesTemp.splice(0, picturesBySlide));
        }

        return (
			<div className="my-2 d-none d-lg-block">
				<Slider
					slides={slides.map((slide, index) => ({
						content: (
							<Row key={index} className="gx-2">
								{slide.map(path => (
									<Col key={`${path}-${index}`} xs={3} className="text-center position-relative">
										<FileLoader filename={path} useAppUrl autoPlay loop muted alt={this.getTranslation('subtitle') || this.getTranslation('name')} className="w-100 rounded-2 object-fit-cover see-picture bg-dark bg-opacity-50" height="100px" loading="lazy" data-path={path} onClick={this.handleSetMainPicture} />
										{/\.(mp4|webm|mpeg)(\?|$)/i.test(path) && (
											<span className="position-absolute top-50 start-50 translate-middle rounded-circle bg-dark bg-opacity-50 d-flex align-items-center justify-content-center pe-none" style={{ width: '36px', height: '36px' }}>
												<Icon icon="eye" className="text-white" />
											</span>
										)}
									</Col>
								))}
							</Row>
						),
					}))}
					disableControls={pictures.length <= picturesBySlide}
					disableLightbox
					label={this.getTranslation('name')}
				/>
			</div>
		);
		// return (
		//     <div>
		//         <div className={classnames('mb-3', isMobileView ? ['d-block', 'd-md-none'] : ['d-none', 'd-md-block'])}>
		//             {isMobileView && <span className="d-flex justify-content-between h6 mb-1 pt-3 border-top text-uppercase"><FormattedMessage id="productPicturesMore" defaultMessage="More pictures" /> <Icon icon="chevron-right" /></span>}
		//             <div className={classnames('overflow-hidden', 'bg-info', 'p-1', 'rounded')} style={{ overflow: 'hidden', height: pictures.length > 0 ? (isMobileView ? `${70 / Math.ceil(pictures.length / 3)}px` : `${100 / Math.ceil(pictures.length / 3)}px`) : '0px' }}>
		//                 <Row className="gx-1">
		//                     {pictures.map((path, index) => (
		//                         <Col key={`${path}-${index}`} xs={isMobileView > 1 ? 4 : 3} className="text-center">
		// 							<FileLoader filename={path} useAppUrl autoPlay loop muted alt={this.getTranslation('subtitle') || this.getTranslation('name')} className="mw-100 rounded see-picture" height={isMobileView ? '70px' : '100px'} loading="lazy" data-path={path} onClick={this.handleSetMainPicture} />
		//                         </Col>
		//                     ))}
		//                 </Row>
		//             </div>
		//             {(pictures.length > 0 || !isMobileView) && <small><em><FormattedMessage id="productPicturesClickToDetail" defaultMessage="Click on the image to enlarge" /></em></small>}
    }

	// Replaced by ProductOfferSelector
    // renderPrice() {
	// 	const product = this.getCurrentProduct();
    //     const displayPriceHT = getUserGroupOption(this.props.userGroup, 'displayPriceHT');
    //     const productPrice = getProductPrice(product, this.props.item?.quantity || 1, this.props.userGroup, !displayPriceHT, this.props.referral) / (this.props.item?.quantity || 1);
	// 	const productSpecialPrice = getProductSpecialPrice(product, displayPriceHT ? 'priceHT' : 'priceTTC', null, this.props.userGroup, this.props.referral);
    //     return (
    //         <Fragment>
    //             <div className="">
    //                 {productPrice > 0 && formatPrice(productPrice) < product[displayPriceHT ? 'priceHT' : 'priceTTC'] && <span className="h4 mb-0 me-1 text-black-70 text-crossed"><Price amount={product[displayPriceHT ? 'priceHT' : 'priceTTC']} formatPrice /></span>}
    //                 <span className="display-5 m-0 p-0 text-danger">
    //                     <strong><Price amount={productPrice} formatPrice /></strong>
    //                 </span>
    //             </div>
    //             <small className="d-block text-uppercase text-black-50">
    //                 {displayPriceHT ? <FormattedMessage id="productUnitPriceExclTax" defaultMessage="Unit price excl. tax" /> : <FormattedMessage id="productUnitPriceInclTax" defaultMessage="Unit price incl. tax" />}
    //             </small>
	// 			{this.state.isMounted && productSpecialPrice && getProductSpecialPriceDateThreshold(productSpecialPrice) && (
	// 				<strong className="text-danger">
	// 					<Icon icon="danger" /> <FormattedMessage id="productSpecialPriceDateThresholdLimit" defaultMessage="Offer ends in {chrono}" values={{ chrono: <Chrono date={getProductSpecialPriceDateThreshold(productSpecialPrice)} displayText /> }} />
	// 				</strong>
	// 			)}
	// 			<ProductSpecialPriceQuantityInfo product={product} />
    //         </Fragment>
    //     );
    // }

    renderHeadlinePrice() {
        const product = this.getCurrentProduct();
        const displayPriceHT = getUserGroupOption(this.props.userGroup, 'displayPriceHT');
        const quantity = this.props.item?.quantity || 1;
        const productPrice = getProductPrice(product, quantity, this.props.userGroup, !displayPriceHT, this.props.referral) / quantity;
        const catalogPrice = product[displayPriceHT ? 'priceHT' : 'priceTTC'];
        return (
			<Fragment>
				<div>
					{productPrice > 0 && formatPrice(productPrice) < catalogPrice && <span className="h5 mb-0 me-2 text-black-70 text-crossed"><Price amount={catalogPrice} formatPrice /></span>}
					<span className="display-6 fw-bold m-0 text-danger"><Price amount={productPrice} formatPrice /></span>
				</div>
                <small className="text-uppercase text-black-50">
                    {displayPriceHT ? <FormattedMessage id="productUnitPriceExclTax" defaultMessage="Unit price excl. tax" /> : <FormattedMessage id="productUnitPriceInclTax" defaultMessage="Unit price incl. tax" />}
                </small>
			</Fragment>
        );
    }

	renderCartSelector() {
		const autoRedirectToCart = getContentBlockItemValue(this.props.page.blocks, 'autoRedirectToCart', 'value');
		if(this.props.product.customizations?.length || this.props.userGroup?.identifier !== USER_GROUP_DEFAULT) {
			return <CartItemQuantitySelector product={this.props.product} variation={this.state.variation} onChangeVariation={this.handleSetVariation} onAddToCart={newQuantity => newQuantity === 1 && autoRedirectToCart && this.props.navigate(getLanguagePath('/cart', this.props.intl.locale))} />;
		}
		return <ProductOfferSelector product={this.props.product} variation={this.state.variation} onChangeVariation={this.handleSetVariation} onAddToCart={newQuantity => newQuantity === 1 && autoRedirectToCart && this.props.navigate(getLanguagePath('/cart', this.props.intl.locale))} />;
	}

    renderShareButton() {
        // const seo = this.getProductSeo();
		const product = this.getCurrentProduct();
        return (
			<div className="mt-2">
				<SocialShare
					type="product"
					id={product.slug}
					title={product.name}
					image={getFile(product.pictures[0]) || ''}
					text={getCmsPageSeoDescription(this.props.page, getTranslation(product, 'description', this.props.intl.locale)) || ''}
					url={`${config.url}/${this.props.intl.locale}/${getProductSlug(product, this.props.intl.locale)}?utm_campaign=product&utm_medium=page&utm_source={network}`}
				/>
			</div>
        );
        // <ButtonGroup size="sm">
        // </ButtonGroup>
        //     <ReactToPrint
        //         trigger={() => {
        //             // NOTE: could just as easily return <SomeComponent />. Do NOT pass an `onClick` prop
        //             // to the root node of the returned component as it will be overwritten.
        //             return <Button variant="dark" outline tag="a" href="#" className="m-1 p-2 rounded"><Icon icon="printer" size="lg" /></Button>;
        //         }}
        //         content={() => this.productPrintRef}
        //         onBeforeGetContent={() => this.setState({ isPrintMode: true })}
        //     />
        //     <div className="d-none">
        //          <ProductPrint ref={elt => { this.productPrintRef = elt; }} product={product} products={this.getProducts()} userGroup={this.props.userGroup} referral={this.props.referral} />
        //     </div>
        // return null;
    }

    renderGroupPanel() {
        const renderGroupPanelContent = () => {
            const groupIdentifier = (this.props.userGroup || {}).identifier || USER_GROUP_DEFAULT;
            switch(groupIdentifier) {
                case 'pro':
                case 'semi-pro':
                case 'mini-pro':
                case 'ce':
                case 'asso':
					return <CmsPanel slug={`product-view-group-${groupIdentifier}`} />;

                case USER_GROUP_DEFAULT:
                default:
					return <CmsPanel slug="product-view-group-individual" />;
            }
        };
        return (
            <div className="my-3 pt-2" style={{ fontSize: '0.8rem' }}>
                <Row>
                    <Col xs="2" className="p-3 pt-4 text-center text-light">
                        <Icon icon="info" size="2x" />
                    </Col>
                    <Col>
                        {renderGroupPanelContent()}
                    </Col>
                </Row>
            </div>
        );
    }

    renderDiscountPanel() {
        return (
			<VoucherProgress />
        );

        // const { userGroup, vouchers, intl } = this.props;
        // if((vouchers || []).length > 0 && vouchers[0]) {
        //     return (
        //         <Alert variant="danger" className="rounded text-lg progress-bar-striped border-5 border-end-0 border-top-0 border-bottom-0">
        //             <Row>
        //                 <Col xs="12" md="3" className="text-center">
        //                     <span className="display-3">🎁</span>
        //                 </Col>
        //                 <Col>
        //                     <HtmlComponent text={getTranslation(vouchers[0], 'description', intl.locale)} /><br />
        //                 </Col>
        //             </Row>
        //         </Alert>
        //     );
        // }
        // return ((userGroup || {}).identifier === USER_GROUP_DEFAULT) && <CmsPanel slug="discount-offers" />;
    }

    renderAssociatedProducts() {
        const associatedProducts = this.getAssociatedProducts();
        if(associatedProducts.length === 0) {
            return false;
        }
        return (
            <div className="py-3 py-md-5 bg-info">
                <Container className="px-0">
                    <div className="text-center mb-4">
                        <span className="d-inline-block mb-0 h3 text-dark text-center border-half-white"><FormattedMessage id="productAssociatedTitle" defaultMessage="You will also like" /></span>
                    </div>
                    {true || this.props.appIsMobile ? (
                        <div className="d-flex flex-nowrap overflow-auto pb-2 px-2 px-md-0" style={{ gap: '0.75rem' }}>
                            {associatedProducts.map(associatedProduct => {
                                const visibleCount = Math.min(associatedProducts.length, 4.5);
                                return (
                                    <div key={associatedProduct._id} className="flex-shrink-0" style={{ width: `calc((100% - ${(visibleCount - 1) * 0.75}rem) / ${visibleCount})`, minWidth: '8rem' }}>
                                        <ProductListItem product={associatedProduct} listId="product-related-products" viewType="mini" />
                                    </div>
                                );
                            })}
                        </div>
                    ) : (
                        <Slider
                            label={this.getTranslation('name')}
                            interval={7000}
                            disableControls={associatedProducts.length <= 3}
                            slides={Array.from({ length: Math.ceil(associatedProducts.length / 3) }, (unused, slideIndex) => ({
                                content: (
                                    <Row className="px-4 px-md-5">
                                        {associatedProducts.slice(slideIndex * 3, (slideIndex * 3) + 3).map(associatedProduct => (
                                            <Col xs="12" md="4" key={associatedProduct._id}>
                                                <ProductListItem product={associatedProduct} listId="product-related-products" />
                                            </Col>
                                        ))}
                                    </Row>
                                ),
                            }))}
                        />
                    )}
                </Container>
            </div>
        );
    }

    renderSummaryNav(sections) {
        if(sections.length < 2) {
            return null;
        }
        return (
            <nav aria-label="Sommaire" className="d-flex gap-2 overflow-auto py-2 my-1">
                {sections.map(section => (
                    <Button variant="superlight" size="sm" key={section.key} onClick={() => this.handleGoToSection(section.key, section.tab)} className="bg-superlight-gradient rounded-pill flex-shrink-0 fw-bold text-black-70 border">
                        {section.label}
                    </Button>
                ))}
            </nav>
        );
    }

    renderProductSheet(composition, nutritionalValues, conservation) {
        const product = this.getCurrentProduct();
        const hasNutrition = nutritionalValues || hasNutritionValues((product.foodData || {}).nutrition) || hasAllergens((product.foodData || {}).allergens);
        if(!composition && !hasNutrition && !conservation) {
            return null;
        }
        return (
            <div className="bg-white-gradient border rounded-3 overflow-hidden">
                {/* <div className="px-3 py-2 small fw-bold text-uppercase text-muted bg-superlight-gradient border-bottom" style={{ letterSpacing: '0.08em' }}>
                    <FormattedMessage id="productSheet" defaultMessage="Product sheet" />
                </div> */}
				<strong id={this.getSectionAnchorId('info')} aria-controls="product-info" aria-expanded={this.state.detailsTab === 'info'} onClick={this.handleOpenInfoTab} className="d-flex justify-content-between align-items-center h6 mb-0 px-3 py-3 text-uppercase see-composition"><FormattedMessage id="productInfo" defaultMessage="Information" /> <Icon icon={this.state.detailsTab === 'info' ? 'chevron-down' : 'chevron-right'} /></strong>
				<Collapse in={this.state.detailsTab === 'info'}>
					<div id="product-info" className="px-3 pb-3">
						{this.renderAttributes()}
						<div className="mt-2">
							{this.renderCategories()}
						</div>
					</div>
				</Collapse>
                {composition && (
                    <Fragment>
                        <strong id={this.getSectionAnchorId('composition')} aria-controls="product-composition" aria-expanded={this.state.detailsTab === 'composition'} onClick={this.handleOpenCompositionTab} className="d-flex justify-content-between align-items-center h6 mb-0 px-3 py-3 border-top text-uppercase see-composition"><FormattedMessage id="productComposition" defaultMessage="Composition" /> <Icon icon={this.state.detailsTab === 'composition' ? 'chevron-down' : 'chevron-right'} /></strong>
                        <Collapse in={this.state.detailsTab === 'composition'}>
                            <div id="product-composition" className="px-3 pb-3">
                                <HtmlComponent text={composition} />
                            </div>
                        </Collapse>
                    </Fragment>
                )}
                {hasNutrition && (
                    <Fragment>
                        <strong id={this.getSectionAnchorId('nutrition')} aria-controls="product-nutrional-values" aria-expanded={this.state.detailsTab === 'nutrional-values'} onClick={this.handleOpenNutritionalValuesTab} className="d-flex justify-content-between align-items-center h6 mb-0 px-3 py-3 border-top text-uppercase see-nutrional-values">
                            <span>
                                <FormattedMessage id="productNutritionalValues" defaultMessage="Nutrional values" />
                                {' & '}
                                <FormattedMessage id="productAllergens" defaultMessage="Allergens" />
                            </span>
                            <Icon icon={this.state.detailsTab === 'nutrional-values' ? 'chevron-down' : 'chevron-right'} />
                        </strong>
                        <Collapse in={this.state.detailsTab === 'nutrional-values'}>
                            <div id="product-nutrional-values" className="px-3 pb-3">
                                <ProductNutrition product={product} fallback={nutritionalValues} />
                                <ProductAllergens product={product} />
                            </div>
                        </Collapse>
                    </Fragment>
                )}
                {conservation && (
                    <Fragment>
                        <strong id={this.getSectionAnchorId('conservation')} aria-controls="conservation" aria-expanded={this.state.detailsTab === 'conservation'} onClick={this.handleOpenConservationTab} className="d-flex justify-content-between align-items-center h6 mb-0 px-3 py-3 border-top text-uppercase see-conservation">
                            <FormattedMessage id="productConservation" defaultMessage="Conservation" />
                            <Icon icon={this.state.detailsTab === 'conservation' ? 'chevron-down' : 'chevron-right'} />
                        </strong>
                        <Collapse in={this.state.detailsTab === 'conservation'}>
                            <div id="conservation" className="px-3 pb-3">
                                <CmsPanel slug={conservation} />
                            </div>
                        </Collapse>
                    </Fragment>
                )}
				<div className="border-top p-3">
					{this.renderShareButton()}
				</div>
            </div>
        );
    }

    renderRecapCard() {
        const product = this.getCurrentProduct();
        const title = getContentBlockItemValue(this.props.page.blocks, 'title') || this.getTranslation('name');
        const autoRedirectToCart = getContentBlockItemValue(this.props.page.blocks, 'autoRedirectToCart', 'value');
        const picture = (product.pictures || [])[0];
        return (
            <div className="bg-white border rounded-3 shadow-sm p-3 my-4">
                <Row className="align-items-center g-3">
                    <Col xs="6" md="2" className="">
                        {picture && <img src={getFile(picture)} alt={title} width="100" height="100" className="w-100 rounded-3" style={{ objectFit: 'cover' }} />}
                    </Col>
                    <Col xs="6" md="4" className="text-center text-md-start">
						<div>
							<strong className="d-block text-dark">{title}</strong>
							{this.isAvailable() && <span className="d-inlineblock ms-2 small fw-bold text-success">✔ <FormattedMessage id="productInStock" defaultMessage="In stock" /></span>}
						</div>
                        <div className="d-block text-center text-md-start">
							<ProductWeight product={product} />
							<StarRating size="sm" textBefore />
                        </div>
                    </Col>
                    <Col xs="12" md="6" className="ms-md-auto text-center">
                        <div className="text-center">
                            {this.renderHeadlinePrice()}
                            <div className="text-center" style={{ minWidth: '210px' }}>
                                <CartItemQuantitySelector product={this.props.product} variation={this.state.variation} disableCustomization disableQuantityEdition disableSubscription disableExtraMessages buttonColor="danger" onChangeVariation={this.handleSetVariation} onAddToCart={newQuantity => newQuantity === 1 && autoRedirectToCart && this.props.navigate(getLanguagePath('/cart', this.props.intl.locale))} />
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
        );
    }

    render() {
        const { userGroup, page, products, referral, intl } = this.props;
        const product = this.getCurrentProduct();
        // <Helmet {...this.getSeo()} />
        const title = getContentBlockItemValue(page.blocks, 'title') || this.getTranslation('name');
        const description = getContentBlockItemValue(page.blocks, 'description') || this.getTranslation('description');
        const composition = getContentBlockItemValue(page.blocks, 'composition') || this.getTranslation('composition');
        const nutritionalValues = getContentBlockItemValue(page.blocks, 'nutritional-values') || this.getTranslation('nutritionalValues');
        const shippingInfoSup = getContentBlockItemValue(page.blocks, 'shipping-info-sup');
        const recommandation = getContentBlockItemValue(page.blocks, 'recommandation');
		const hideRecommandation = getContentBlockItemValue(page.blocks, 'hideRecommandation', 'value');
        // const voucherInfo = getContentBlockItemByName(page.blocks, 'voucher-info');
        const breadcrumbs = getContentBlockItemsByName(page.blocks, 'breadcrumbs');
        const conservation = getContentBlockItemValue(page.blocks, 'conservation');
        const faqSlugs = getContentBlockItemsByName(page.blocks, 'faq').map(item => item.text).filter(Boolean);
        const hasNutrition = nutritionalValues || hasNutritionValues((product.foodData || {}).nutrition) || hasAllergens((product.foodData || {}).allergens);
        const summarySections = [
            description && { key: 'description', label: <FormattedMessage id="productDescription" defaultMessage="Description" /> },
            composition && { key: 'composition', label: <FormattedMessage id="productComposition" defaultMessage="Composition" />, tab: 'composition' },
            hasNutrition && { key: 'nutrition', label: <FormattedMessage id="productNutritionalValues" defaultMessage="Nutritional values" />, tab: 'nutrional-values' },
            conservation && { key: 'conservation', label: <FormattedMessage id="productConservation" defaultMessage="Conservation" />, tab: 'conservation' },
            faqSlugs.length > 0 && { key: 'faq', label: <FormattedMessage id="productFaq" defaultMessage="FAQ" /> },
            { key: 'reviews', label: <FormattedMessage id="reviews" defaultMessage="Reviews" /> },
        ].filter(Boolean);

        if(this.props.product && product) {
            return (
                <Fragment>
					<ProductSeo product={product} page={page} />
                    <ProductSnippet product={product} description={description} userGroup={userGroup} />
                    <Container fluid="xl" className="page-wrapper">
                        <Row className="g-0 g-md-3 g-lg-4">
                            <Col xs="12" lg="6" className="position-relative mb-2">
                                <Breadcrumbs crumbs={[...breadcrumbs, !breadcrumbs.length && title]} hiddenCrumbs={breadcrumbs.length ? [title] : []} />
                                {this.renderMainPicture()}
                                {this.isAvailable() && this.renderSlider(true)}

                                {this.isAvailable() && (
                                    <Fragment>
                                        {this.renderSlider()}
										{getProductOption(product, 'mainPictureOrientation') !== 'portrait' && !this.getAdditionnalPictures().length && (
											<div className="d-none d-md-block">
												{this.renderDiscountPanel()}
											</div>
										)}
                                    </Fragment>
                                )}
                            </Col>
                            <Col xs="12" lg="6">
                                <div className="px-2 px-md-0 pb-1">
                                    {title && <h1 className="mt-1 mt-lg-4 mb-1 pb-0 text-dark text-center text-md-start">{title}</h1>}

                                    <div className="d-flex align-items-center justify-content-between gap-2 mb-2">
										<div>
											{product.brand && (
												<div className="text-center text-md-start">
													{product.brand}
												</div>
											)}
											{this.isAvailable() && <span className="ms-md-auto small fw-bold text-success">✔ <FormattedMessage id="productInStock" defaultMessage="In stock" /></span>}
										</div>
                                        <StarRating size="sm" centered inline textBefore />
                                    </div>

                                    <div className="d-flex flex-wrap align-items-baseline justify-content-between gap-2 mb-2">
                                        <div className="text-center text-md-start">
											{product.weight > 0 && (
												<OverlayTrigger
													placement="bottom"
													overlay={
														<Tooltip id={`product-weight-${product._id}`}>
															<CmsPanel slug="product-weight-information" />
														</Tooltip>
													}
												>
													<strong className="h5"><ProductWeight product={product} hideLabel /> <small><Icon icon="info" id={`product-weight-${product._id}`} className="text-light" /></small></strong>
												</OverlayTrigger>
											)}
											<br />
                                            <ProductCapacityPrice product={product} />
                                            {getCartQuantityStep(product, userGroup) > 1 && <div className="pt-1 small"><Icon icon="cube" /> <FormattedMessage id="productPacking" defaultMessage="Box of {count} unit(s)" values={{ count: getCartQuantityStep(product, userGroup) }} /></div>}
                                        </div>
										<div className="text-end">
											{this.renderHeadlinePrice()}
										</div>
                                    </div>

                                    {product.isPack && (
                                        <div className="text-start mb-2">
                                            {product.items.map(item => (
                                                <span key={item.productId} className="d-block mt-1 py-1 border-top border-light">
                                                    <strong className="h6 text-secondary fs-4">{item.quantity}</strong> x {getTranslation((products.find(product => item.productId === product._id) || {}), 'name', intl.locale)}
                                                </span>
                                            ))}
                                        </div>
                                    )}

                                    <div className="my-3">
                                        {this.isAvailable() ? this.renderCartSelector() : <strong className="d-block h6 text-danger text-center text-md-end"><FormattedMessage id="productNotAvailable" defaultMessage="Not available" /></strong>}
                                    </div>

									{(getProductOption(product, 'mainPictureOrientation') === 'portrait' || this.getAdditionnalPictures().length > 0) && this.renderDiscountPanel()}

									{
										getProductOption(product, 'mainPictureOrientation') === 'portrait'
										? (
											<div className="mt-2">
												<HtmlComponent text={description} useCollapse collapsedSize="20" />
												{this.renderProductSheet(composition, nutritionalValues, conservation)}
											</div>
										) : this.renderSummaryNav(summarySections)
									}
                                </div>
                            </Col>
                        </Row>

						{getProductOption(product, 'mainPictureOrientation') !== 'portrait' && (
							<Row className="mt-0 mb-lg-4 gx-lg-5 border-top pt-4">
								<Col xs="12" lg="8" id={this.getSectionAnchorId('description')}>
									<HtmlComponent text={description} useCollapse collapsedSize="40" />

									{shippingInfoSup && <HtmlComponent text={shippingInfoSup} />}
								</Col>
								<Col xs="12" lg="4">
									{this.renderProductSheet(composition, nutritionalValues, conservation)}
								</Col>
							</Row>
						)}

                        {faqSlugs.length > 0 && (
                            <div className="py-3" id={this.getSectionAnchorId('faq')}>
                                {faqSlugs.map(slug => <CmsPanel key={slug} slug={slug} />)}
                            </div>
                        )}
                    </Container>

                    {!this.isAvailable() && this.renderAssociatedProducts()}

                    <div className="critical-css-limiter">
						{!hideRecommandation && (recommandation ? <CmsPanel slug={recommandation} /> : <ProductRelatedPosts products={[product]} categories={this.getTranslation('categories')} excerptSize={30} count={CMS_RELATED_POSTS_COUNT} mode="mini" />)}
                    </div>

                    {this.isAvailable() && this.renderAssociatedProducts()}

                    <div id={this.getSectionAnchorId('reviews')}>
                        <ReviewSummary />
                    </div>

                    {/* {this.isAvailable() && (
                        <div className="bg-info">
                            <Container className="my-3 py-3 px-md-0">
                                <Row className="pt-3">
                                    <Col xs="12" md="6" className="position-relative">
										{this.renderMainPicture()}
                                    </Col>
                                    <Col>
                                        <div className="px-2 px-md-0 pb-3">
                                            {title && <span className="mb-2 mb-md-0 mt-2 mt-md-n2 h1 text-dark text-center text-md-start">{title}</span>}
                                            <Row>
                                                <Col xs="6">
                                                    <ProductWeight product={product} /><br />
                                                    {((userGroup || {}).conditions || []).some(condition => condition.key === 'packFill') && <FormattedMessage id="productPacking" defaultMessage="Box of {count} unit(s)" values={{ count: product.packing }} />}
                                                </Col>
                                                <Col className="text-end">
                                                    {this.renderPrice()}
                                                </Col>
                                            </Row>

                                            <div className="mb-3">
                                                <CartItemQuantitySelector product={product} onChangeVariation={this.handleSetVariation} disableQuantityEdition buttonColor="danger" />
                                            </div>

                                            {((userGroup || {}).identifier === USER_GROUP_DEFAULT) && <CmsPanel slug="shipping-information" />}
                                        </div>
                                    </Col>
                                </Row>
                            </Container>
                        </div>
                    )} */}
					{this.isAvailable() && !this.props.product.customizations?.length && (
						<Container className="my-2 py-2 px-md-0">
							{this.renderRecapCard()}
						</Container>
					)}

					{((userGroup || {}).identifier === USER_GROUP_DEFAULT) && (
						<Container fluid className="py-3 my-3 bg-info border-bottom">
							<CmsPanel slug="shipping-information" />
						</Container>
					)}

                    <div className="">
                        <PreFooter />
                    </div>

                </Fragment>
            );
        }
        return <ErrorPage />;
    }
}

function mapStateToProps(store, props) {
    const product = props.product || getProduct(store, getContentBlockItemValue(props.page.blocks, 'product')) || null;
    return {
        currency: getCurrentCurrency(store),
        userGroup: getUserGroup(store),
        product,
		item: getCartItemByProduct(store, product),
        products: memoizedGetProducts(store, { isActive: true }),
        vouchers: getCartVouchers(store),
        appIsMobile: store.app.isMobile,
        // siteTitlePanel: memoizedGetPanelBySlugAndLanguage(store, 'site-title', (store.intl || {}).locale),
        referral: getReferral(store),
    };
}

ProductViewPage.defaultProps = {
    currency: defaultCurrency,
    product: null,
    item: null,
    userGroup: null,
    products: [],
    vouchers: [],
    // siteTitlePanel: null,
    referral: null,
};

ProductViewPage.propTypes = {
    page: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    navigate: PropTypes.func.isRequired,
    params: PropTypes.object.isRequired,
    search: PropTypes.object.isRequired,
    intl: PropTypes.object.isRequired,
    currency: PropTypes.string,
    product: PropTypes.object,
    item: PropTypes.object,
    userGroup: PropTypes.object,
    products: PropTypes.arrayOf(PropTypes.object),
    vouchers: PropTypes.arrayOf(PropTypes.object),
    appIsMobile: PropTypes.bool,
    // siteTitlePanel: PropTypes.object,
    referral: PropTypes.string,
};

export default connect(mapStateToProps)(withRouter(injectIntl(ProductViewPage)));
